module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("ADJUDICATED")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("O")]), _vm._v("ne way or another we all must make a decision about those important values that guide your life even if you do not live by choices premeditated")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("But at some point, in time on this or the other side of the veil you will have to make a decision on the ultimate fate of your soul and this time the decision will be predicated and adjudicated.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Regardless of the value system that you do embody")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("It will have eternal consequences that you cannot avoid because you chose to put your soul on the line in order to have a glorified mortal body.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Long before any world was ever formed in this dispensation")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You knowingly went to war to defend God the Father’s decision to use Christ’s plan of redemption that mandated your free agency to make the choice to seek out Christ for your redemption without a single equivocation.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Somewhere deep down inside your soul there is a small child that is lost in the web of lies that Satan uses as bait in the world of the natural man")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("But before you can escape perdition’s gory grasp, there must be an absolute recognition of sacrifice that Christ knowingly chose to ensure that the full price had been paid.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The doors of heaven were opened to those that actively sought out God the Father’s iron rod of holy laws and Christ ensured a way back home by using his redemption plan.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("One way or another we all have to make a decision about those important values that guide your life even if you do not live by choices premeditated")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("But at some point, in time on this or the other side of the veil you will have to make a decision on the ultimate fate of your soul and this time the choice will be predicated and adjudicated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70aa635e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap004.vue
// module id = 78
// module chunks = 0